/** Hungarian labels and icons per notification type, mirroring statusLabels.ts. */
export const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  INQUIRY_CREATED: "Új szállásigény",
  INQUIRY_UPDATED: "Szállásigény módosult",
  OFFER_PUBLISHED: "Új ajánlat",
  OFFER_ACCEPTED: "Ajánlat elfogadva",
  OFFER_DECLINED: "Ajánlat elutasítva",
  BOOKING_CREATED: "Új foglalás",
  BOOKING_STATUS_CHANGED: "Foglalás módosult",
  SYSTEM_MESSAGE: "Rendszerüzenet",
};

export const NOTIFICATION_TYPE_ICONS: Record<string, string> = {
  INQUIRY_CREATED: "mdi-file-document-outline",
  INQUIRY_UPDATED: "mdi-file-document-edit-outline",
  OFFER_PUBLISHED: "mdi-tag-outline",
  OFFER_ACCEPTED: "mdi-check-circle-outline",
  OFFER_DECLINED: "mdi-close-circle-outline",
  BOOKING_CREATED: "mdi-calendar-check-outline",
  BOOKING_STATUS_CHANGED: "mdi-calendar-edit-outline",
  SYSTEM_MESSAGE: "mdi-information-outline",
};

export const notificationTypeLabel = (type: string): string =>
  NOTIFICATION_TYPE_LABELS[type] ?? type;

export const notificationTypeIcon = (type: string): string =>
  NOTIFICATION_TYPE_ICONS[type] ?? "mdi-bell-outline";
